export default __webpack_public_path__ + "static/media/contactus-banner2.25f8e5db.jpg";